(function () {
  function fallbackCopy(text) {
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.feber-share-copy');
    if (!btn) return;

    const url = btn.dataset.copyUrl;

    // Safari / iOS / older browsers
    if (!navigator.clipboard) {
      fallbackCopy(url);
      btn.classList.add('is-copied');
      return;
    }

    navigator.clipboard.writeText(url)
      .then(() => {
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 350);
      })
      .catch(() => fallbackCopy(url));
  });
})();
